<template>
  <div class="queueNav">
    <a v-if="showUpArrow" @click.prevent="moveUp(jobs, name, index, type)" href="#"><i class="queueNav__icon fa fa-arrow-circle-up"></i></a>
    <a v-if="showDownArrow" @click.prevent="moveDown(jobs, name, index, type)" href="#"><i class="queueNav__icon fa fa-arrow-circle-down"></i></a>
    <button-cta :onClick="close" theme="close"><span aria-hidden="true">&times;</span></button-cta>
  </div>
</template>

<script>
import ButtonCta from '@/components/Button/button'
export default {
  name: 'QueueNav',
  components: {
    ButtonCta
  },
  props: {
    id: Number,
    name: String,
    moveUp: Function,
    moveDown: Function,
    remove: Function,
    jobs: Array,
    index: Number,
    type: String
  },
  mounted () {
  },
  data: () => ({}),
  computed: {
    showUpArrow () {
      return this.index > 0
    },
    showDownArrow () {
      return this.index < this.jobs.length - 1
    }
  },
  methods: {
    close () {
      this.remove(this.jobs, this.id, this.name, this.type)
    }
  }
}
</script>

<style lang="scss">
    .queueNav {
      width: 160px;
      text-align: right;
      float: right;
      &__icon {
        font-size: 24px;
        margin-right: 5px;
      }
    }
</style>



// WEBPACK FOOTER //
// src/components/AdminBatch/admin-queue-nav.vue